import React from 'react'

import { Box, Heading3, Paragraph, TextAlign } from '@gousto-internal/citrus-react'

import { welcomeSectionTexts } from 'routes/Home/PriceComparisonTable/constants'

import { SectionContainer } from '../Containers.styled'

export function WelcomeSection() {
  return (
    <SectionContainer
      paddingV={[10, 10, 10, 0]}
      paddingBottom={[0, 0, 0, 0]}
      data-testid="WelcomeSectionContainer"
    >
      <Heading3 textAlign={[TextAlign.Center, null, TextAlign.Left]}>
        {welcomeSectionTexts.heading}
      </Heading3>
      <Box paddingV={4} paddingBottom={[0, 0, 6, 6]}>
        <Paragraph fontWeight={400} size={3} textAlign={[TextAlign.Center, null, TextAlign.Left]}>
          {welcomeSectionTexts.subheading}
        </Paragraph>
      </Box>
    </SectionContainer>
  )
}
